const UserVisibilityPlugin = (store) => {
  const USER_IDLE_AFTER = app.TIME.minute(1);
  const SESSION_IDLE_AFTER = app.TIME.minute(30);

  let lastTouched = Date.now();
  let isUserAway = null;
  let isSessionIdle = null;
  let isTabHidden = null;
  let key;
  let event;

  const keys = {
    hidden: 'visibilitychange',
    webkitHidden: 'webkitvisibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
  };

  for (key in keys) {
    if (key in document) {
      event = keys[key];
      break;
    }
  }

  const _visibilityKey = key;
  const _visibilityEvent = event;
  isTabHidden = document[_visibilityKey];

  const updateTouch = _.throttle(function () {
    lastTouched = Date.now();
  }, app.TIME.SECOND);

  const checkUserActive = function () {
    isTabHidden = document[_visibilityKey];
    const passedTime = Date.now() - lastTouched;

    isUserAway = passedTime > USER_IDLE_AFTER;
    store.commit('setUserVisibility', !isUserAway && !isTabHidden);

    isSessionIdle = passedTime > SESSION_IDLE_AFTER;
    store.commit('setUserSessionActivity', !isSessionIdle);
  };

  window.addEventListener('click', updateTouch);
  window.addEventListener('mousemove', updateTouch);
  window.addEventListener('keyup', updateTouch);
  document.addEventListener(_visibilityEvent, checkUserActive);
  setInterval(checkUserActive, app.TIME.SECOND);
};
export default UserVisibilityPlugin;
